import { getLatestToken as getLatestTokenFromAzureAD } from './msal';

const getLatestToken = async () => {
  const isForAutomationTest =
    localStorage.getItem('isForAutomationTest') === 'true';
  if (isForAutomationTest) {
    return {
      accessToken: localStorage.getItem('automationTestAccessToken') || '',
    };
  }
  return getLatestTokenFromAzureAD();
};

export { getLatestToken };
